import { Locale } from 'src/common/types/locale';

export const formatNumber = (numb: number, locale: Locale = 'en-US') =>
  numb.toLocaleString(locale);
